module.exports = __webpack_public_path__ + "static/media/eCommerce User Journeys_CN edits - dte_1621433828078.2f9d29f0.docx";